const reasons = [
  {
    icon: 'ri-settings-5-line',
    title: 'Tipos de Máquinas',
    items: ['Cunha Quente Automática', 'Cunha Quente Manual', 'Extrusora Manual'],
  },
  {
    icon: 'ri-stack-line',
    title: 'Materiais Compatíveis',
    items: ['PEAD (Polietileno de Alta Densidade)', 'PVC (Policloreto de Vinila)', 'LLDPE (Polietileno Linear)', 'PP (Polipropileno)'],
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Vantagens',
    items: ['Importador oficial no Brasil', 'Garantia de 6 a 12 meses', 'Suporte técnico pós-venda', 'Peças de reposição originais'],
  },
];

export default function WhySection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-10 md:mb-14 text-center">
          <span className="text-primary-500 text-xs uppercase tracking-widest mb-2 block">Diferenciais</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 uppercase leading-tight">Por que Escolher Nossos Equipamentos</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {reasons.map((reason) => (
            <div key={reason.title} className="bg-white rounded-2xl border border-background-200/70 p-6 md:p-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mb-5">
                <i className={`${reason.icon} text-primary-600 text-xl`} />
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 uppercase mb-4">{reason.title}</h3>
              <ul className="space-y-3">
                {reason.items.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-foreground-600 text-sm">
                    <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}